var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    (!_vm.label && _vm.labeled && _vm.isRestrict && _vm.$store.state.auth.user.token) ||
    (!_vm.label && !_vm.labeled && _vm.isRestrict && _vm.$store.state.auth.user.token)
  )?_c('span',[_c('v-icon',{staticStyle:{"margin-bottom":"2px"},attrs:{"size":"10px","color":"grey darken-0"}},[_vm._v("mdi-lock")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }